import React, { useContext } from 'react';
import { PlayerModalContext } from '../contexts/PlayerModalContext';

const PlayerLink = ({ mlbId, name, style = {} }) => {
  const context = useContext(PlayerModalContext);
  const openPlayerModal = context?.openPlayerModal || null;

  return (
    <span
      onClick={() => mlbId && openPlayerModal && openPlayerModal(mlbId, null)}
      style={{
        cursor: mlbId && openPlayerModal ? 'pointer' : 'default',
        transition: 'color 0.12s',
        ...style,
      }}
      onMouseEnter={e => { if (mlbId && openPlayerModal) e.currentTarget.style.color = '#ffffff'; }}
      onMouseLeave={e => { if (mlbId && openPlayerModal) e.currentTarget.style.color = style.color || ''; }}
    >
      {name}
    </span>
  );
};

export default PlayerLink;
